import React from 'react'
import classNames from 'classnames'
import { node, string, oneOfType, object, array } from 'prop-types'

const Footer = ({ children, className }) => (
  <tfoot className={classNames('sw-table-footer', className)}>{children}</tfoot>
)

Footer.displayName = 'Footer'

Footer.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default Footer
